export default {
  customer: {
    prev: "Previous",
    nextv: "Next page",
    noAuth: "You do not have permission to view this video ",
    catchword: "Belief in the Power of Innovation ",
    placeholderSearch: "Keyword ",
    pleaseLogin: "Hello! Please login ",
    level1: "Project Category :",
    home: "Home ",
    reset: "Reset",
    unit1: " ",
    unit2: " ",
    coursevalue: "Course value ",
    noData: "Haven't found anything yet.",
    pleaseReview: "Rate the course: ",
    publish: "Publish",
    reviewArea: "Comment area ",
    pubSuc: "Successfully published",
    me: "Me",
  },
  global: {
    allTestComp: 'All tasks have been completed',
    test: 'Task not started',
    testEnd: 'Task has ended',
    view: 'people watching',
    identity1: "Internal Employees",
    identity2: "Strategic Customers",
    pleaseChoose: "Select login identity ",
    docTitle1: "itc Business School ",
    docTitle2: "Zhizhi Conference Recording Platform ",
    forget: "Forget your password?",
    warningTitle: "Copyright notice",
    warning:
      "The copyright of this course is owned by Guangdong Baolun Electronics Co., LTD., only for personal learning, and any form of recording, transmission and account sharing is strictly prohibited. Once found, the company will retain the right to pursue in accordance with the law, and in serious cases, it will bear legal responsibility. ",
    sectionNum: "{num} Section",
    sort1: "Primary classification",
    sort2: "Secondary classification",
    pleaseSignIn: "please sign in",
    image: "picture",
    search: "Search",
    choose: "Please select",
    searchKeyword: 'Please enter the keyword for the query',
    keyword: "Keyword",
    sure: "Sure",
    save: "Save",
    submit: "Submit",
    cancel: "Cancel",
    noData: "Haven't found anything yet.",
    noDataTable: "There are currently no updates, please stay tuned",
    play: "Play",
    noCate: "There is no classification for the time being",
    noPoster: "There is no cover for the time being",
    top: "Set at the top",
    download: "Download",
    downCount: "Downloads",
    allowDown: "Allow download",
    allowShare: "Allow shared",
    resourceCate: "Resource Cate",
    back: "Return",
    yes: "Yes",
    no: "No",
    all: "All",
    allCate: "All Categories",
    defaultSort: "Default classification",
    uploadTime: "Upload time",
    keepTime: "Preservation time",
    size: "Size",
    score: "Score",
    check: "Check",
    copy: "Copy",
    copySuccess: "Copy succeeded",
    type: "Type",
    collect0: "Favorite canceled",
    collect1: "Successful collection",
    tips: "Hint",
    nokeyword: "There are no keywords",
    forever: "Permanently preserved",
    halfYear: "Half a year",
    oneYear: "A year",
    month: " months",
    loading: "Loading",
    selectDate: "Select a date",
    authorityMessage:
      "No viewing permission, please contact the administrator to activate",
    authorityMessage1:
      "The current video has limited viewing rights, please log in to view",
    copyUrlmessage:
      "Copy the link and send the user to view the shared content through the web page or H5",
    webUrl: "Web side",
    H5Url: "Mobile",
    linkUrl: "Link",
    successfullyScored: "Successfully scored",
    complete: "Complete",
  },
  form: {
    web: 'Official website',
    companyName: 'Company Name',
    changePass: "Reset password",
    certify: "Identification",
    certifySuc: "Successful authentication",
    getCodeSuc: "The verification code has been sent",
    reGetCode: "reacquire",
    getCode: "Get verification code",
    phoneNumErr: "Mobile phone number error",
    phoneNumber: "Mobile phone number",
    position: " Position",
    email: "Mailbox",
    email1: "Please enter your email address",
    emailEmpty: "Mailbox cannot be empty",
    rightEmail: "Please enter the correct mailbox",
    phone: "Mobile phones",
    phone1: "Please enter your cell phone number",
    phone2: "Please enter your cell phone number",
    rightPhone: "Please enter the correct mobile phone number",
    pleaseInput: "Please enter the content of your question",
    typeEmpty: "Please select the question type",
    codeEmpty: "Please enter a verification code",
    codeError: "Please enter the correct verification code",
    maxl20: "You can enter up to 20 characters",
    submiting: "Saving is in progress, please do not refresh the browser",
    resEmpty: "Please fill in the name of the information",
    chooseFile: "Please upload the file",
    addr: "Address",
    number: "Contact number",
  },
  response: {
    timeOut: "The request timed out",
  },
  modules: {
    live: "Live online",
    video: "Video on Demand",
    settings: "Account setup",
  },
  rules: {
    enterAcc: "Please enter the account number",
    account:
      "The account number consists of 4 ~ 16 digits in English, numbers and underscores",
    pwd:
      "The password consists of 6 ~ 16 digits in English or numbers or underscores",
    strongPwd:
      "The password limit is 8~16, consisting of 3 or more combinations of numbers, uppercase letters, lowercase letters, and special symbols",
    spaceKey: "Do not enter spaces",
    trim: "There must be no spaces before or after the content",
    leftTrim: "Content must not be preceded by spaces",
    rightTrim: "Content must not be followed by spaces",
    mobile: "The phone format is incorrect",
    ip: "Please enter the correct ip address",
    port: "Please enter the correct port",
    mask: "Please enter the correct subnet mask",
    chinese: "Do not enter special characters",
    link: "The link format is incorrect",
  },
  upload: {
    pic: "Upload pictures",
    success: "Upload successful",
    fail: "Upload failed",
    error: "There was a mistake while uploading",
    uploading: "Uploading,please wait while",
    paused: "Pause",
    waiting: "Waiting for upload",
    imgType: "Only files in picture format are allowed to be uploaded",
    score2M: "Only files within 2M are allowed to be uploaded",
  },
  homepage: {
    studyTest: 'Learning tasks',
    special_tcamp: "Special training camp",
    product_focus: "New Teach Well",
    nice_video: "Recommendation",
    Visitors: "Tourists are not allowed to enter",
    noOpen: "This feature is not yet available",
    needLogin: "This feature needs to be logged in before it can be used",
    pleaseLogin: "Hello, please log in",
    loginFirst: "Please sign in first",
    register: "Register",
    changeRole: "Switch identities",
    manage: "Management Center",
    settings: "Account setup",
    loginOut: "Safe exit",
    newRes: "Latest information",
    more: "More",
    moreVideo: "More videos",
    hotVideo: "Popular video",
    aboutUs: "About us",
    news: "Press bulletin",
    newsDetail: "Information details",
    annex: "Annex",
    latest: "The latest information",
    like0: "No praise",
    like1: "Praise has been given",
    operation: "Operating Manual",
    question: "Frequently asked questions",
    user: "User feedback",
    write: "Fill in feedback",
    feedback: "Question feedback",
    tips1:
      "Please fill in the problems you encountered in the use process below, and we will carefully read your feedback! ",
    tips2:
      "Please describe the problems you encounter in as much detail as possible, and your feedback will be the best guarantee for us to improve the quality of the platform",
    identify: "Can't see clearly, please change another one",
    questionType: "Type of problem",
    selectQues: "Please select the question type",
    yourEmail: "Your mailbox",
    msgEasy: "It is convenient for us to contact you more quickly",
    code: "Verification code",
    string4: "Enter four characters on the right",
    resource: "resources",
    album: "Album",
    time: "Time",
    resource_cate: "Classification",
    uploadResource: "Upload resources",
    ranking: "Download Ranking",
    uploadRes: "Upload resources",
    downloadRes: "Download information",
    chooseRes: "Select data",
    resTypes:
      "Support common document, picture, audio, compressed file and other formats",
    resName: "Data name",
    Moderated: "Please wait for the administrator to audit",
    shareLink: "Share links",
    transcoding:
      "In the process of transcoding, wait a moment to refresh the page to watch",
    deleted: "The current data has been deleted",
    onlyDown:
      "This information is for download only and preview is not supported",
    canotDown: "The creator of this data is not allowed to download",
    course: "Courses",
    learner: "Number of students",
    catalog: "Album catalogue",
    introduction: "Introduction to the album",
    video: "Video",
    videoDeleted: "Video has been deleted",
    test: "Test paper",
    chapter: "Chapter 1",
    playCounts: "Total playback volume",
    popularity: "Popularity",
    heat: "Hot",
    testDetail: "Details of the examination paper",
    fullMarks: "Full marks",
    marks: "Minutes",
    difficulty: "Difficulty",
    answer: "Answer",
    statistics: "Statistics",
    result1: "A total of 2 questions, 1 point",
    result2: "This question was answered twice with a correct rate of 1%",
    analysis: "Analysis",
    closeAnalysis: "Turn off analysis",
    checkAnalysis: "View parsing",
    downTest: "Download the test paper",
    template: "Template",
    A4: "A4 paper is arranged vertically",
    A3: "A3 paper is arranged vertically",
    answerType1: "The questions are followed by the answers",
    answerType2: "The test questions are separated from the analysis",
    answerType3: " only download test papers",
    answerType4: " only Download the answers",
    videoCate: "Video classification",
    videoIntr: "Video profile",
    testStatus: 'complete',
    hasComplete: 'incomplete',
    videoNotice: "Video instructions",
    classIntr: "Introduction to the course",
    teacherIntr: "Introduction by the lecturer",
    comment: "Comment",
    plaComment: "Come and comment, boldly want to say what you think~",
    yes: "Determine",
    comments: "Comments",
    score: "Rate the course",
    teacherInfo: "Instructor information",
    otherClass: "Other courses",
    watched: "People who have seen it",
    enterLive: "Enter the studio",
    forbitted: "You have been restricted from watching",
    checkArea: "View the limits",
    noAllow: "Range that cannot be viewed",
    inputPsw: "Enter the live password",
    pswSetted:
      "The live broadcast has a viewing password, which needs to be entered to watch",
    getPsw: "Please contact the speaker: {speaker} to obtain the password",
    living: "Live",
    notStart: "Not started",
    liveOver: "The live broadcast is over",
    liveNeedLogin: "The live broadcast requires to login to watch",
    liveName: "Name of the live broadcast",
    liveTime: "Live broadcast time",
    onlineCounts: "Number of people online",
    liveIntr: "Live introduction",
    barrageOpen: "The barrage has been opened",
    barrageOff: "The barrage is closed",
    connect: "The network is abnormal, please check the network",
    discuss: "Forum",
    yourWord: "Write down what you want to say",
    member: "Member",
    shareAddr: "Share Address",
    forbit: "You have been banned",
    forbit2:
      "This word has been disabled, please re-enter the discussion content",

    grading: "Rate the course",
    profileHolder: "Come and review it, boldly want to say what you think",
    cutImage: "screenshot",
    edit: "edit",
    delete: "delete",
    commontCutImage: "Comment screenshot",
    addComments: "Please enter the content of the comment",
    delCommentsWhat: "Are you sure you want to delete this comment",
    delSuccess: "successfully deleted",
    notDel: "Undeleted",
  },
  register: {
    relogin: "Log in again?",
    gologin: "Return to login",
    strongPwd:
      "The password contains 8 to 16 digits, uppercase letters, lowercase letters, and more than three types of special symbols",
    login: "Sign in",
    account: "Account number",
    hasAccount: "You already have an account? ",
    hasAccount2: "You already have an account? ",
    back: "Return to login",
    username: "User name",
    namePl: "Please fill in your real name",
    nameEmpty: "The real name cannot be empty",
    gender: "Gender",
    genderEmpty: "Sex cannot be null",
    male: "Male",
    female: "Female",
    department: "Department",
    inputDepartment: "Please select department",
    accountEmpty: "The account number cannot be empty",
    psw: "Password",
    psw1: "Please enter your password",
    newPsw: "Please enter a new password",
    nowPsw: "Current password",
    imputOldPsw: "Please enter your old password",
    psw6: "Please enter a 6-digit password",
    pswtip:
      "The password consists of 6-16 digits in English, numbers, and underscores",
    psw16: "Password length is 6 ~ 16 characters",
    pswEmpty: "Password cannot be empty",
    checkPsw: "Confirm the password",
    psw200: "Password modification succeeded",
    checkPswPl: "Repeat the password",
    checkTwice: "Please enter your password again",
    noSame: "The password entered twice is inconsistent",
    rememberTip: "Important information for login, please keep in mind!",
    submit: "Submit registration",
    confirmed: "Confirmed and submitted for registration",

    noAccount: "No account ?",
    signUpNow: "Sign up now",
    loginPlease: "Welcome to log in ~",

    newPassword: "New password",
    surePassword: "Confirm password",
    changeSuccess: "Modify successfully, please log in again",
  },
  settings: {
    title1: "Basic Information",
    title2: "Change Password",
    avatar: "Head portrait",
    loginAcc: "Log in to the account",
    relName: "Please enter your real name",
    replace: "Replace",
    intro: "Personal profile",
    introTip: "Show everyone your unique side",
  },
  cdkey: {
    systemOverdue0: "System is out of date",
    systemOverdue: "Your system has expired",
    getRegistrationKey:
      "In order not to affect your use, please contact the relevant salesperson to obtain the registration code",
    serialNumber: "Serial Number",
    placeholder1: "Paste the obtained serial number here",
    RegistrationCode: "Registration code",
    placeholder2: "Paste the obtained activation code here",
    activation: "activation",
    partTime: "Effective time",
    partModel: "Mobile activation module",
    android: "Android",
    OnActivation: "activated",
    UnActivation: "inactivated",
    message: "Please enter the registration code",
    activationSuccess: "Activated successfully",
    activationFail: "Activation fails",
    InfiniteDays: "Infinite Days",
  },
};
